import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { fetchProduct, fetchProducts } from '../apis/product';

const PAGE_SIZE = 20;
const STALE_MS = 1000 * 60;

/** Catalogue pages for a search term ('' = everything). Home and the book list share the
 *  unfiltered pages. */
export const useProductPages = (q = '') =>
  useInfiniteQuery({
    queryKey: ['products', q],
    queryFn: ({ pageParam }) => fetchProducts({ page: pageParam, size: PAGE_SIZE, q }),
    initialPageParam: 1,
    getNextPageParam: (last) => (last.page < last.total_pages ? last.page + 1 : undefined),
    // Keep the current list on screen while a new search loads
    placeholderData: keepPreviousData,
    staleTime: STALE_MS,
  });

export const isNotFound = (error: unknown) => isAxiosError(error) && error.response?.status === 404;

export const useProduct = (slug: string | undefined) =>
  useQuery({
    queryKey: ['product', slug],
    queryFn: () => fetchProduct(slug as string),
    enabled: Boolean(slug),
    staleTime: STALE_MS,
    // A missing product stays missing
    retry: (failureCount, error) => !isNotFound(error) && failureCount < 3,
  });
